import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getPaystubById } from '../api/paystubsApi';
import backIcon from "../assets/backIcon.png";
import orangeDownloadIcon from "../assets/orange_download.png";


// const earnings = [
//     {
//       earning: 'Salaried',
//       rate : "-",
//       hour: "40",
//       current: '$1,000.00',
//       ytd: '$1,000.00',
//     },
//   ];

// const empTexesWithheld = [
//     {
//       tax: 'Employer FICA Tax',
//       current: '$62.00',
//       ytd: '$62.00',
//     },
//     {
//         tax: 'Federal Unemployment Tax',
//         current: '$6.00',
//         ytd: '$6.00',
//       },
//       {
//         tax: 'Employer Medicare Tax',
//         current: '$14.50',
//         ytd: '$14.50',
//       },
//   ];

//   const postTaxDeduction = [
//     {
//       deduction: 'Miscellaneous',
//       current: '$1,000.00',
//       ytd: '$1,000.00',
//     },
//   ];

const PaystubsDetails = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
  
    const companyId = queryParams.get('companyId');
    const employeeId = queryParams.get('employeeId');
    const payrollId = queryParams.get('payrollId');

    console.log("====", { companyId, employeeId, payrollId });

    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => {
          try {
            const res = await getPaystubById(companyId, employeeId, payrollId);
            setData(res.data);
          } catch (error) {
            console.error("Error fetching paystub details:", error);
          } finally {
            setLoading(false);
          }
        };
        fetchDetails();
      }, [companyId, employeeId, payrollId]);

        const formatDate = (dateStr) => dateStr
          ? new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
          : "-";

        const summary = useMemo(() => data?.summary || {}, [data]);
        const payroll = useMemo(() => data?.payroll || {}, [data]);
        const employee = useMemo(() => data?.employee || {}, [data]);
        const company = useMemo(() => data?.company || {}, [data]);

        const address = useMemo(() => company?.address
            ? `${company.address.street1}, ${company.address.city}, ${company.address.state}, ${company.address.zipcode}, ${company.address.country}`
            : "-", [company]);

        const companyAddress = useMemo(() => {
            const a = company?.address;
            return a ? [a.street1, a.city, a.state, a.zipcode, a.country].filter(Boolean).join(', ') : '-';
          }, [company]);
        
          const earnings = useMemo(() => (data?.earnings || []).map(e => ({
            earning: e.description || e.code,
            rate: e.rate !== null ? `$${e.rate.toFixed(2)}` : "-",
            hour: e.hours?.toFixed(2),
            current: `$${e.amount?.toFixed(2)}`,
            ytd: `$${e.amountYtd?.toFixed(2)}`
          })), [data]);
        
          const empTexesWithheld = useMemo(() => (data?.employeeTaxes || []).map(e => ({
            tax: e.description,
            current: `$${e.amount.toFixed(2)}`,
            ytd: `$${e.amountYtd.toFixed(2)}`
          })), [data]);
        
          const reimbursements = useMemo(() => (data?.reimbursements || []).map(r => ({
            description: r.description,
            current: `$${r.amount.toFixed(2)}`,
            ytd: `$${r.amountYtd.toFixed(2)}`
          })), [data]);
        
          const employeeBenefits = useMemo(() => (data?.employeeBenefitContributions || []).map(b => ({
            description: b.description,
            current: `$${b.amount.toFixed(2)}`,
            ytd: `$${b.amountYtd.toFixed(2)}`
          })), [data]);
        
          const postTaxDeduction = useMemo(() => (data?.postTaxDeductions || []).map(d => ({
            deduction: d.description,
            current: `$${d.amount.toFixed(2)}`,
            ytd: `$${d.amountYtd.toFixed(2)}`
          })), [data]);

          const handleClick = () => {
            navigate('/paystubs'); 
          };
    

    return (
        <div className='p-4'>
            <div className='d-flex align-items-center'><img src={backIcon} onClick={handleClick} alt='' style={{ width: "14px", margin: "-6px 6px 0px 0px", cursor:"pointer" }} />
                <h4 className="mb-2 main-title-for-all">Paystub Details</h4>
            </div>

            <p className="gray-text-for-content mb-4">Get a clear breakdown of your earnings, taxes, deductions, and net pay for each pay period.</p>


            <div className="mb-4 p-4 bg-white rounded">

                <div className='mb-4 position-relative'>
                    
                    <div className="row " style={{ border: "1px solid #C4C4C480", borderRadius: "10px", padding: "22px 20px", margin: "0px 3px 0px 3px" }}>
                    <img src={orangeDownloadIcon} alt='' style={{right: "-8px", maxWidth: "45px", width: "100%", position: "absolute",top: "0px"}} />
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content  mb-1'>Employee Id</p>
                            <p className='information-text mb-3'>{employee?.employeeId || "-"}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Payroll Id</p>
                            <p className="information-text mb-3">{payroll?.payrollId || "-"}</p>
                        </div>
                    </div>
                </div>

                <div className='mb-4'>
                    <h5 className='sub-title'>Company</h5>
                    <div className="row " style={{ border: "1px solid #C4C4C480", borderRadius: "10px", padding: "22px 20px", margin: "22px 3px 0px 3px" }}>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content  mb-1'>Legal Name</p>
                            <p className='information-text mb-3'>{company?.legalName || "-"}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>DBA Name</p>
                            <p className="information-text mb-3">{company?.tradeName || "-"}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content  mb-1'>Address</p>
                            <p className='information-text mb-3'>{address}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content  mb-1'>Phone</p>
                            <p className='information-text mb-3'>{company?.phone || "-"}</p>
                        </div>
                    </div>
                </div>

                <div className='mb-2'>
                    <h5 className='sub-title'>Summary</h5>
                    <div className="row " style={{ border: "1px solid #C4C4C480", borderRadius: "10px", padding: "22px 20px", margin: "22px 3px 0px 3px" }}>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content  mb-1'>Payday</p>
                            <p className='information-text mb-3'>{formatDate(payroll?.payday) || '-'}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Pay period</p>
                            <p className="information-text mb-3">{formatDate(payroll?.periodStart)} → {formatDate(payroll?.periodEnd)}</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Total hours</p>
                            <p className="information-text mb-3">40</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Net pay</p>
                            <p className="information-text mb-3">$423.50<br />
                                $423.50 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Gross pay</p>
                            <p className="information-text mb-3">$1,000.00<br />
                                $1,000.00 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Reimbursements</p>
                            <p className="information-text mb-3">$0.00<br />
                                $0.00 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Employee Benefits</p>
                            <p className="information-text mb-3">$0.00<br />
                                $0.00 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Company Benefits</p>
                            <p className="information-text mb-3">$0.00<br />
                                $0.00 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Post-tax Deductions</p>
                            <p className="information-text mb-3">$500.00<br />
                                $500.00 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Employee Taxes</p>
                            <p className="information-text mb-3">$76.50<br />
                                $76.50 (YTD)</p>
                        </div>
                        <div className='col-4 p-0'>
                            <p className='gray-text-for-content mb-1'>Company Taxes</p>
                            <p className="information-text mb-3">$103.00<br />
                                $103.00 (YTD)</p>
                        </div>
                    </div>

                </div>

                <div className=" bg-white px-0 py-4 rounded">
                    <h5 className="mb-3 sub-title">Earnings</h5>
                    <div className="table-responsive table-border-layout">
                        <table style={{ width: "100%" }}>
                            <thead >
                                <tr className='table-head'>
                                    <th>Earning</th>
                                    <th>Rate</th>
                                    <th>Hours</th>
                                    <th>Current</th>
                                    <th>YTD</th>
                                </tr>
                            </thead>
                            <tbody className='gray-text-for-content'>
                                {earnings.map((stub, idx) => (
                                    <tr key={idx}>
                                        <td>{stub.earning}</td>
                                        <td>{stub.rate}</td>
                                        <td>{stub.hour}</td>
                                        <td>{stub.current}</td>
                                        <td>{stub.ytd}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className=" bg-white px-0 py-4 rounded">
                    <h5 className="mb-3 sub-title">Employee Taxes Withheld</h5>
                    <div className="table-responsive table-border-layout">
                        <table style={{ width: "100%" }}>
                            <thead >
                                <tr className='table-head'>
                                    <th>Tax</th>
                                    <th>Current</th>
                                    <th>YTD</th>
                                </tr>
                            </thead>
                            <tbody className='gray-text-for-content'>
                                {empTexesWithheld.map((stub, idx) => (
                                    <tr key={idx}>
                                        <td>{stub.tax}</td>
                                        <td>{stub.current}</td>
                                        <td>{stub.ytd}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className=" bg-white px-0 py-4 rounded">
                    <h5 className="mb-3 sub-title">Reimbursements</h5>
                    <div className="table-responsive table-border-layout">
                        <table style={{ width: "100%" }}>
                            <thead >
                                <tr className='table-head'>
                                    <th>Reimbursement</th>
                                    <th>Current</th>
                                    <th>YTD</th>
                                </tr>
                            </thead>
                            <tbody className='gray-text-for-content'>
                                
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className=" bg-white px-0 py-4 rounded">
                    <h5 className="mb-3 sub-title">Employee Benefit Contributions</h5>
                    <div className="table-responsive table-border-layout">
                        <table style={{ width: "100%" }}>
                            <thead >
                                <tr className='table-head'>
                                    <th>Benefit</th>
                                    <th>Current</th>
                                    <th>YTD</th>
                                </tr>
                            </thead>
                            <tbody className='gray-text-for-content'>
                               
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className=" bg-white px-0 py-4 rounded">
                    <h5 className="mb-3 sub-title">Post-tax Deductions</h5>
                    <div className="table-responsive table-border-layout">
                        <table style={{ width: "100%" }}>
                            <thead >
                                <tr className='table-head'>
                                    <th>Deduction</th>
                                    <th>Current</th>
                                    <th>YTD</th>
                                </tr>
                            </thead>
                            <tbody className='gray-text-for-content'>
                            {postTaxDeduction.map((stub, idx) => (
                                    <tr key={idx}>
                                        <td>{stub.deduction}</td>
                                        <td>{stub.current}</td>
                                        <td>{stub.ytd}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaystubsDetails;
